import { Box, LinearProgress, Grid, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { getPresignedURLForPut, fileUploadToS3, IFile } from 'wisestep-api';
import { WsFileUpload, WsButton } from 'wisestep-base';

import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

export interface IUploadFile {
  onCancel?: () => void;
  onContinue: (file: IFile) => void;
  isLoading?: boolean;
}
const UploadFile = ({ onCancel, onContinue, isLoading }: IUploadFile) => {
  const [disable, setDisable] = useState(true);

  const [progress, setProgress] = useState(10);

  const [file, setFile] = useState<IFile>({
    name: '',
    location: '',
  });

  const setNotification = useNotificationStore((state) => state.setNotification);

  const onUploadProgress = (progressEvent: ProgressEvent) => {
    const { loaded, total } = progressEvent;
    const percent = Math.floor((loaded * 100) / total);
    setProgress(percent);
  };

  const uploadFile = async (file: File[]) => {
    if (!file) return;

    await getPresignedURLForPut({ fileName: file[0].name, fileType: file[0].type })
      .then(async (response) => {
        setFile({ location: response.data.preSignedUrl, name: file[0].name });
        await fileUploadToS3(file[0], response.data.preSignedUrl, onUploadProgress);
        setNotification(success('Uploaded file(s) successfully!'));
        setDisable(false);
      })
      .catch(() => setNotification(failed('Failed to upload file')));
  };
  return (
    <Box pt={2}>
      <WsFileUpload
        name="file"
        onUpload={(file: File[]) => {
          uploadFile(file);
        }}
        multiple={false}
        maxFileSize={5}
        placeholderText="Drag & drop .pdf or .docx file "
        placeholderHelperText={file?.name}
      />
      {file?.location && (
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      )}
      <Grid item container xs={12} justifyContent="flex-end" pt={2}>
        <WsButton variant="text" onClick={onCancel}>
          Cancel
        </WsButton>
        <WsButton
          variant="outlined"
          onClick={() => onContinue(file)}
          disabled={isLoading || disable}
          endIcon={isLoading ? <CircularProgress size={17} color="secondary" /> : <></>}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </WsButton>
      </Grid>
    </Box>
  );
};

export default UploadFile;
